import moment from "moment";

const DATE_FORMAT = "YYYY-MM-DD";
const DATE_TIME_FORMAT = "YYYY-MM-DD HH:mm:ss";
const CERTIFICATE_DATE_FORMAT = "DD MMMM YYYY";

const formatDate = (date, format = DATE_FORMAT) => {
    if (!date) {
      return null;
    }

    return moment(date).utc().format(format);
}

const formatDateTime = (date, format = DATE_TIME_FORMAT) => {
    if (!date) {
      return null;
    }

    return moment(date).utc().format(format);
}

const formats = {
  DATE_FORMAT,
  DATE_TIME_FORMAT,
  CERTIFICATE_DATE_FORMAT
}

export default {
    formatDate,
    formatDateTime,
    formats
};